import { Controller } from "@hotwired/stimulus";
import { resumeUrlKey } from "../utils/quiz_offline_cache";

export default class extends Controller {
  connect() {
    const params = new URLSearchParams(window.location.search);
    params.delete("source");
    const query = params.toString();
    window.history.replaceState(
      window.history.state,
      "",
      `${window.location.pathname}${query ? `?${query}` : ""}${window.location.hash}`,
    );
    this.element.remove();

    const resumeUrl = localStorage.getItem(resumeUrlKey(document.body.dataset.userId));
    if (resumeUrl?.startsWith("/") && !resumeUrl.startsWith("//")) window.location.replace(resumeUrl);
  }
}
